/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Keyword } from './keyword';


export interface CategoryRequest { 
    key: string;
    name: string;
    keywords?: Array<Keyword>;
    parentId?: number;
    lang?: string;
}

